import { API } from '@/config/api';
import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Trophy, Flame, Lock, Crown } from 'lucide-react';


export default function Achievements() {
  const { user } = useOutletContext();
  const [achievements, setAchievements] = useState(null);
  const [streak, setStreak] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [achRes, streakRes] = await Promise.all([
        fetch(`${API}/profile/achievements`, { credentials: 'include' }),
        fetch(`${API}/profile/streak`, { credentials: 'include' })
      ]);

      if (achRes.ok) setAchievements(await achRes.json());
      if (streakRes.ok) setStreak(await streakRes.json());
    } catch (error) {
      console.error('Failed to fetch:', error);
    }
  };

  if (!achievements || !streak) {
    return <div className="p-8 text-center">Loading...</div>;
  }

  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto" data-testid="achievements-page">
      <h1 className="text-4xl font-bold mb-8">Achievements</h1>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <Card className="p-6 glass-card">
          <div className="flex items-center gap-3 mb-2">
            <Trophy className="h-8 w-8 text-primary" />
            <h2 className="text-3xl font-bold">{achievements.unlocked}/{achievements.total}</h2>
          </div>
          <p className="text-muted-foreground">Achievements Unlocked</p>
        </Card>

        <Card className="p-6 glass-card">
          <div className="flex items-center gap-3 mb-2">
            <Flame className="h-8 w-8 text-destructive" />
            <h2 className="text-3xl font-bold">{streak.current_streak} days</h2>
          </div>
          <p className="text-muted-foreground">Current Streak</p>
          <p className="text-xs text-muted-foreground mt-1">Best: {streak.best_streak} days</p>
        </Card>
      </div>

      {/* Achievements List */}
      <div className="space-y-3">
        {achievements.achievements.map((achievement) => (
          <Card
            key={achievement.id}
            className={`p-6 glass-card ${
              achievement.unlocked ? 'border-primary/50' : 'opacity-60'
            }`}
          >
            <div className="flex items-center gap-4">
              <div className="text-4xl">{achievement.icon}</div>
              <div className="flex-1">
                <h3 className="text-xl font-bold flex items-center gap-2">
                  {achievement.name}
                  {!achievement.unlocked && <Lock className="h-4 w-4 text-muted-foreground" />}
                </h3>
                <p className="text-muted-foreground">{achievement.description}</p>
              </div>
              {achievement.unlocked && (
                <div className="text-success font-bold">✓</div>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
